import React, { useState, useEffect, useRef } from "react";
import { Tabulator, FormatModule, EditModule } from "tabulator-tables";
import "tabulator-tables/dist/css/tabulator.min.css";
import validateRow from "../validators/RowValidator.js";
import { Button } from "@material-ui/core";

Tabulator.registerModule([FormatModule, EditModule]);

const fields = ["email", "phone", "fName", "lName"];
const styles = {
    table: {
        width: "80%",
        height: "80%",
        color: "gray",
        fontFamily: "verdana",
    },
    pBarBG: {
        margin: "20px",
        width: "80%",
        height: "20px",
        backgroundColor: "gray",
        display: "none",
    },
    pBar: {
        height: "20px",
        color: "white",
        fontWeight: "bold",
        fontFamily: "verdana",
        backgroundColor: "#03a9f4",
        textAlign: "center",
        display: "none",
    },
    btn: {
        color: "white",
        borderRadius: "10px",
        backgroundColor: "#03a9f4",
        margin: "10px",
        display: "none",
    },
};

const EditableSpreadSheet = (props) => {
    const { tableData } = props;
    const tableRef = useRef(null);
    const addButtonRef = useRef(null);
    const [uploadTotal, setUploadTotal] = useState(0);
    const [uploadedCount, setUploadedCount] = useState(0);
    const [tabulator, setTabulator] = useState(null);

    useEffect(() => {
        if (tableData[0] && !tabulator) {
            const newTabulator = new Tabulator(tableRef.current, {
                reactiveData: true,
                data: tableData,
                maxHeight: 500,
                layout: "fitColumns",
                selectable: 1,
                rowFormatter: checkRow,
                rowSelected: checkRow,
                rowDeselected: checkRow,
                columns: [
                    { title: "First Name", field: "fName", editor: true },
                    { title: "Last Name", field: "lName", editor: true },
                    { title: "Phone", field: "phone", editor: true },
                    { title: "Email", field: "email", editor: true },
                ],
            });
            setTabulator(newTabulator);
            tableRef.current.style.display = "inline-block";
            addButtonRef.current.style.display = "inline-block";
        }
    }, [tableData, tabulator]);

    const checkRow = (row) => {
        const data = row.getData();
        const color = (bgColor) =>
            fields.map(
                (column) =>
                    (row.getCell(column).getElement().style.backgroundColor = bgColor)
            );
        if (!validateRow(data).valid) {
            color("#FFD1C7");
            validateRow(data).columns.map(
                (column) =>
                (row.getCell(column).getElement().style.backgroundColor =
                    "rgba(255, 0, 0, 0.3)")
            );
        } else {
            color("#FFFFFF");
        }
    };

    const addRow = async () => {
        const tableL = tableData.length;
        const row = await tabulator.updateOrAddRow(tableL, {}, true);
        tableData[tableL] = row._row.data;
    };

    return (
        <div>
            <div>
                <Button
                    ref={addButtonRef}
                    style={styles.btn}
                    onClick={() => addRow()}
                >
                    add row
                </Button>
            </div>
            <div>
                <div ref={props.pbarbgref} style={styles.pBarBG}>
                    <div ref={props.pbarref} style={styles.pBar}></div>
                </div>
            </div>
            <div style={styles.table} ref={tableRef} />
        </div>
    );
};

export default EditableSpreadSheet;
